import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const ShieldCheck = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M4 6.68046C4 6.06252 4.56229 5.56231 5.17628 5.49256C6.16976 5.37969 7.67966 4.9719 9.25911 3.67334C9.68572 3.3226 10.3143 3.3226 10.7409 3.67334C12.3203 4.9719 13.8302 5.37969 14.8237 5.49256C15.4377 5.56231 16 6.06252 16 6.68046V8.68335C16 11.6925 14.4961 14.5026 11.9923 16.1718L11.6641 16.3906C10.6564 17.0624 9.3436 17.0624 8.3359 16.3906L8.0077 16.1718C5.50391 14.5026 4 11.6925 4 8.68335V6.68046Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M12 9L10 11L8.5 9.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default ShieldCheck;